var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "var(--icon-color)",
    strokeWidth: "800px",
    height: "800px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78,0H6A5.9966,5.9966,0,0,0,0,6V54a5.9966,5.9966,0,0,0,6,6H27.3083C35.8872,69.6313,36,79.1191,36,90a5.9966,5.9966,0,0,0,6,6c25.2773,0,29.2559-12.82,29.8828-24H78A18.02,18.02,0,0,0,96,54V18A18.02,18.02,0,0,0,78,0ZM12,12H24V48H12ZM84,54a6.0078,6.0078,0,0,1-6,6H66a5.9966,5.9966,0,0,0-6,6c0,10.4883,0,16.4063-12.0645,17.7188C47.6426,73.5234,45.9258,62.4844,36,51.5977V12H78a6.0078,6.0078,0,0,1,6,6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.b7f3e7171342a47cb40ff7732a521942.svg";
export { ForwardRef as ReactComponent };